import React, {
  useReducer,
  createContext,
  useContext,
} from "react";

const initialState = {
  features: [
    {
      name: "excel",
      description: "Excel reporting modules",
      active: false,
    },
    {
      name: "dashboard",
      description: "Excel reporting modules",
      active: true,
    },
    {
      name: "runtime_item_groups",
      description: "Enhance info message with icon and link",
      active: true,
    },
  ],
  loading: false,
  error: null,
};

export const FeatureContext = createContext();

const reducer = (state, action) => {
  switch (action.type) {
    case "IB/FEATURE_FLAG_SET":
      return {
        features: action.payload,
        loading: false,
        error: null,
      };
    case "IB/FEATURE_FLAG_UPDATE":
      return Object.assign({}, state, {
        ...state,
        features: state.features
          .slice(0, action.payload.index)
          .concat([
            {
              ...state.features[action.payload.index],
              active: action.payload.active,
            },
          ])
          .concat(state.features.slice(action.payload.index + 1)),
      });
    default:
      throw new Error();
  }
};

export const FeatureContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <FeatureContext.Provider value={[state, dispatch]}>
      {props.children}
    </FeatureContext.Provider>
  );
};

export const useFeatureContext = () => {
  const context = useContext(FeatureContext);

  if (context === undefined) {
    throw new Error("useFeatureContext was used outside of its Provider");
  }

  return context;
};

